module.exports = __webpack_public_path__ + "static/media/p01.febdbb84.jpg";